import React, { useState } from 'react';
import PerfumeCard from '../components/PerfumeCard';
import bannerImage from '../images/spice_image/spice_banner.jpg';
import spice1 from '../images/spice_image/spice_turmeric.jpg';
import spice2 from '../images/spice_image/spice_cumin.jpg';
import spice3 from '../images/spice_image/spice_cardamom.jpg';
import spice4 from '../images/spice_image/spice_cloves.jpg';
import spice5 from '../images/spice_image/spice_coriander.jpg';


import cardamom75 from '../images/spice_image/cardamom_75mm_no25.jpg';
import cardamomLR23 from '../images/spice_image/cardamom_lr_23.jpg';
import cardamomLR22 from '../images/spice_image/cardamom_lr_22.jpg';
import cardamomLR15Old from '../images/spice_image/cardamom_lr_15_old.jpg';
import cardamomLR185 from '../images/spice_image/cardamom_lr_185.jpg';

import nutmeg from '../images/spice_image/nutmeg_jaayaphal.jpg';
import mace from '../images/spice_image/mace_jaavitree.jpg';
import clove from '../images/spice_image/clove_laung.jpg';

import blackPepper from '../images/spice_image/black_pepper.jpg';
import blackPepperBold from '../images/spice_image/black_pepper_bold.jpg';


export default function IndianSpicesCollection() {
  const [hoveredId, setHoveredId] = useState(null);
  const [query, setQuery] = useState('');

  const ITEMS = [
  {
    id: "s1",
    name: "Cardamom (7.5mm) NO - 25",
    description: "Medium-sized green cardamom pods with a fresh, sweet aroma, commonly used in cooking, beverages, and spice blends.",
    img: cardamom75
  },
  {
    id: "s2",
    name: "Cardamom LR NO - 23",
    description: "Long, premium-grade green cardamom pods known for strong aroma, rich flavor, and uniform appearance.",
    img: cardamomLR23
  },
  {
    id: "s3",
    name: "Cardamom LR NO - 22",
    description: "High-quality long cardamom pods with balanced color and aroma, ideal for culinary and commercial use.",
    img: cardamomLR22
  },
  {
    id: "s4",
    name: "Cardamom LR NO - 15 (OLD)",
    description: "Aged cardamom pods with a slightly muted green color and warm, mellow aroma.",
    img: cardamomLR15Old
  },
  {
    id: "s5",
    name: "Cardamom LR NO - 185",
    description: "Mixed long-grade cardamom pods offering good aroma and value, suitable for bulk and industrial use.",
    img: cardamomLR185
  },
  {
    id: "s6",
    name: "Nutmeg (Jaayaphal)",
    description: "Warm and sweet whole spice with a rich aroma, widely used in desserts, beverages, and savory dishes.",
    img: nutmeg
  },
  {
    id: "s7",
    name: "Mace (Jaavitree)",
    description: "Aromatic spice with a delicate, warm flavor derived from nutmeg aril, used in baking and spice blends.",
    img: mace
  },
  {
    id: "s8",
    name: "Clove (Laung)",
    description: "Strong, pungent spice with a warm aroma, commonly used in cooking, beverages, and traditional remedies.",
    img: clove
  },
  {
    id: "s9",
    name: "Black Pepper (Kali Mirch)",
    description: "Classic spice with sharp heat and robust aroma, essential in everyday cooking and seasoning.",
    img: blackPepper
  },
  {
    id: "s10",
    name: "Black Pepper (Kali Mirch) - Bold",
    description: "Premium bold peppercorns with larger size, intense flavor, and higher pungency.",
    img: blackPepperBold
  }
];


  const normalized = q => q.trim().toLowerCase();
  const filtered = ITEMS.filter(item => {
    const q = normalized(query);
    if (!q) return true;
    return item.name.toLowerCase().includes(q);
  });

  return (
    <div className="container app-content" style={{ paddingTop: 12 }}>
      {/* Banner */}
      <div style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 24px rgba(15,23,42,0.06)' }}>
        <img
          src={bannerImage}
          alt="Indian spices banner"
          style={{ width: '100%', height: 260, objectFit: 'cover', display: 'block' }}
        />
      </div>

      {/* Title */}
      <h2 className="page-title" style={{ marginTop: 18 }}>
        Indian Spices Collection
      </h2>
      <p className="page-sub">
        A rich selection of authentic Indian spices sourced for purity and aroma.
      </p>

      {/* Search */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 14 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: '#fff',
            border: '2px solid var(--success)',
            padding: '12px 14px',
            borderRadius: 12,
            boxShadow: '0 6px 18px rgba(15,23,42,0.03)',
            maxWidth: 360,
            width: '100%',
            height: 56
          }}
        >
          <input
            placeholder="Search spices"
            className="input"
            value={query}
            onChange={e => setQuery(e.target.value)}
            style={{
              border: 'none',
              padding: 0,
              outline: 'none',
              width: '100%',
              background: 'transparent',
              height: '100%',
              fontSize: 16
            }}
          />
          {query && (
            <button
              onClick={() => setQuery('')}
              className="btn secondary"
              style={{ padding: '8px 12px', fontWeight: 600, height: 36 }}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Collection */}
      <div className="collection-grid" role="list">
        {filtered.length === 0 ? (
          <div className="alert">No matching spices found.</div>
        ) : (
          filtered.map(item => (
            <div role="listitem" key={item.id}>
              <PerfumeCard
                item={item}
                category="Indian Spices"
                hoveredId={hoveredId}
                setHoveredId={setHoveredId}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
